import { useEffect } from 'react';
import { X } from 'lucide-react';
import { cn } from '../utils/cn';

export default function Modal({ isOpen, onClose, title, children, size = 'md' }) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const sizeClasses = {
    sm: 'max-w-md',
    md: 'max-w-2xl',
    lg: 'max-w-4xl',
    xl: 'max-w-6xl',
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4"
      onClick={onClose}
    >
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" />
      
      {/* Modal */}
      <div
        className={cn(
          'relative bg-surface dark:bg-surface-dark rounded-2xl shadow-2xl w-full',
          sizeClasses[size],
          'max-h-[90vh] overflow-hidden flex flex-col',
          'animate-slide-up'
        )}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-border dark:border-border-dark bg-gradient-to-r from-surface-secondary/50 to-transparent dark:from-surface-secondary-dark/50">
          <h2 className="text-xl font-bold text-text dark:text-text-dark">{title}</h2>
          <button
            onClick={onClose}
            className="p-2 rounded-lg hover:bg-surface-secondary dark:hover:bg-surface-secondary-dark transition-colors text-text-secondary dark:text-text-secondary-dark hover:text-text dark:hover:text-text-dark"
            aria-label="Close modal"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto custom-scrollbar p-6">
          {children}
        </div>
      </div>
    </div>
  );
}
